const receiveCouponIconUrlMap = {
	ru: "https://t.rightinthebox.com/tights/litb/8s9swxicjio0_ru.png",
	sv: "https://t.rightinthebox.com/tights/litb/5xnq8yu6w0g0_sv.png",
	ar: "https://t.rightinthebox.com/tights/litb/1kcd0qko2leo0_ar.png",
	fi: "https://t.rightinthebox.com/tights/litb/1x2hxrtort340_fi.png",
	he: "https://t.rightinthebox.com/tights/litb/1znu4chezpr40_he.png",
	hu: "https://t.rightinthebox.com/tights/litb/1dnjk66m0bz40_hu.png",
	fr: "https://t.rightinthebox.com/tights/litb/1qmjzrrtzd4w0_fr.png",
	pl: "https://t.rightinthebox.com/tights/litb/1l4l63269kdc0_pl.png",
	no: "https://t.rightinthebox.com/tights/litb/167po3uw1p400_no.png",
	nl: "https://t.rightinthebox.com/tights/litb/1x8t6y7bbv7k0_nl.png",
	pt: "https://t.rightinthebox.com/tights/litb/1pvvvd08oygw0_pt.png",
	it: "https://t.rightinthebox.com/tights/litb/22u0eh60eb5s0_it.png",
	ja: "https://t.rightinthebox.com/tights/litb/y6juw7s56tc0_ja.png",
	gr: "https://t.rightinthebox.com/tights/litb/1hjfp5kv89sw0_gr.png",
	ro: "https://t.rightinthebox.com/tights/litb/1yixanu1wv8g0_ro.png",
	da: "https://t.rightinthebox.com/tights/litb/1y47r8r4jbpc0_da.png",
	cz: "https://t.rightinthebox.com/tights/litb/1fs369fql9ls0_cz.png",
	en: "https://t.rightinthebox.com/tights/litb/kp1t3fa2fto0_en.png",
	de: "https://t.rightinthebox.com/tights/litb/20oofif5cs800_de.png",
	es: "https://t.rightinthebox.com/tights/litb/1jhnyiufjc800_es.png",
};

function getReceivedCouponIcon(lang: string = "en") {
	return receiveCouponIconUrlMap[Reflect.has(receiveCouponIconUrlMap, lang) ? lang : "en"];
}

export { receiveCouponIconUrlMap, getReceivedCouponIcon };
